import { render, staticRenderFns } from "./SettingRedemtionRate.vue?vue&type=template&id=7e4f0bca"
import script from "./SettingRedemtionRate.vue?vue&type=script&lang=js"
export * from "./SettingRedemtionRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports